import { ReactNode } from "react";
import { Link as RouterLink, LinkProps } from "react-router-dom";
import "./index.scss";

type Props = LinkProps & {
  children?: ReactNode;
  text?: string;
};

export function Link(props: Props) {
  const { text, children, className, ...rest } = props;
  return (
    <RouterLink className={`link ${className}`} {...rest}>
      {text} {children && children}
    </RouterLink>
  );
}
